import React from 'react'
import api from 'core/api/contentstack'
import references from 'core/api/references'
import Recipe from 'core/components/Recipe'
import Listing from 'core/components/Listing'
import { RecipeCard } from 'core/components/Card'
import { layoutData } from 'core/layout'
import { toRecipeListingItem } from 'core/helpers/listing'

const Recipes = (props: any) =>
  props.item ? <Recipe {...props} /> : <Listing {...props} card={RecipeCard} useInfiniteScroll={true} />

export default Recipes

export async function getStaticProps(context: any) {

  const filterId = context.params?.slug && context.params?.slug[0].split(":")[0]
  const recipeId = context.params?.slug && context.params?.slug[1]

  if (recipeId) {
    let item: any, layout: any
    try {
      ;[item, layout] = await Promise.all([
        api.getEntryByToken('recipe', recipeId, context.locale, references.RECIPE_DETAIL),
        layoutData(api, context.locale),
      ])
    } catch (err) {
      console.error('getStaticProps (recipes/[recipeId]): fetch failed', err)
      return { notFound: true, revalidate: 60 }
    }

    // revalidate: false — recipe token not found in CMS. Cache permanently;
    // re-rendering every 60s for a nonexistent recipe token wastes ISR queue slots.
    if (!item) return { notFound: true, revalidate: false }

    return {
      props: { layout: true, ...layout, item },
      revalidate: 43200,
    }
  }

  let items: any, result: any, layout: any
  try {
    ;[items, result, layout] = await Promise.all([
      api.getEntriesByContentTypeFilter("recipe", context.locale, filterId, ["filters", "product", "product.color"]),
      api.getEntryByUrl("listing", `/recipes`, context.locale, references.RECIPE_LISTING),
      layoutData(api, context.locale),
    ])
  } catch (err) {
    console.error('getStaticProps (recipes/listing): fetch failed', err)
    return { notFound: true, revalidate: 60 }
  }

  // revalidate: false — listing CMS entry not found. Cache permanently.
  if (!result) return { notFound: true, revalidate: false }

  return {
    props: { layout: true, ...layout, items: (items ?? []).map(toRecipeListingItem).filter(Boolean), result, prefix: "recipes" },
    revalidate: 43200,
  }
}

export async function getStaticPaths() {
  let recipesEN: any, recipesFR: any, recipesCA: any
  try {
    ;[recipesEN, recipesFR, recipesCA] = await Promise.all([
      api.getEntriesByContentType('recipe', 'en-US', ['filters']),
      api.getEntriesByContentType('recipe', 'fr', ['filters']),
      api.getEntriesByContentType('recipe', 'en-CA', ['filters']),
    ])
  } catch (err) {
    console.error('getStaticPaths (recipes): fetch failed', err)
    return { paths: [], fallback: 'blocking' }
  }

  const getFilterSlugs = (recipes: any[]) =>
    Array.from(new Set(
      (recipes ?? [])
        .filter((recipe: any) => recipe.filters?.length > 0)
        .map((recipe: any) => recipe.filters[0].value)
    ))

  const mapSlugs = (slugs: string[], locale: string) =>
    slugs.map((slug) => ({ params: { slug: [slug] }, locale }))

  return {
    paths: [
      ...mapSlugs(getFilterSlugs(recipesEN), 'en-US'),
      ...mapSlugs(getFilterSlugs(recipesFR), 'fr'),
      ...mapSlugs(getFilterSlugs(recipesCA), 'en-CA')
    ],
    fallback: 'blocking'
  }
}
